import $ from "jquery";

export function getBtn(evt: JQuery.ClickEvent): JQuery<HTMLElement> {
    const target = $(evt.target);
    return target.hasClass("btn") ? target : getParentBtn(target.parent());
}

export function getParentBtn(obj: JQuery<HTMLElement>): JQuery<HTMLElement> {
    return obj.hasClass("btn") ? obj : getParentBtn(obj.parent());
}